var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Sort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "0 0 32 0 32 20 32 32 0 32"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 16.000000) rotate(-270.000000) translate(-16.000000, -16.000000) translate(7.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0000765,0.708491994 L11.0000765,9.24836815 C10.9945055,9.64578727 11.2940536,9.97706795 11.6793093,9.99950646 C11.841511,10.0056863 12.0008558,9.95367305 12.1299886,9.85236869 L12.2292666,9.77879981 L17.5331398,5.71706168 L17.6895562,5.5964087 C18.00796,5.38004261 18.0958103,4.93885001 17.8858266,4.61080635 C17.8332593,4.52870348 17.7647646,4.45873947 17.6845566,4.40532846 L17.533854,4.28835393 L12.2485508,0.23838682 C12.0285679,0.0522575414 11.7550177,-0.0838448956 11.4364711,0.0603501188 C11.1684919,0.188433547 10.9978623,0.46600895 11.0000765,0.770289858 L11.0000765,0.827673588",
    id: "Path",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64559747e-05,0.708491994 L7.64559747e-05,9.24836815 C-0.0054945393,9.64578727 0.294053591,9.97706795 0.679309341,9.99950646 C0.841511011,10.0056863 1.00085576,9.95367305 1.12998857,9.85236869 L1.22926657,9.77879981 L6.53313976,5.71706168 L6.68955616,5.5964087 C7.00795997,5.38004261 7.09581028,4.93885001 6.88582661,4.61080635 C6.83325927,4.52870348 6.7647646,4.45873947 6.68455655,4.40532846 L6.53385399,4.28835393 L1.24855078,0.23838682 C1.02856789,0.0522575414 0.755017738,-0.0838448956 0.436471086,0.0603501188 C0.168491928,0.188433547 -0.00213765753,0.46600895 7.64559747e-05,0.770289858 L7.64559747e-05,0.827673588",
    id: "Path",
    fill: "#333333",
    transform: "translate(3.500000, 5.000000) rotate(-180.000000) translate(-3.500000, -5.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ba71df6ec969155dce524ae00261af68.svg";
export { ForwardRef as ReactComponent };